module.exports = __webpack_public_path__ + "img/box-arrow-down-left.c2bce3d5.svg";